import { configureStore } from '@reduxjs/toolkit'
import loaderSlice from './Slices/loaderSlice'
import AllAvailableAccess from './Slices/AllAvailableAccess'


export const store = configureStore({
    reducer: {
        loader: loaderSlice,
        allAvailableAccess: AllAvailableAccess,
    },
})